import { useEffect, useRef } from 'react';

import { getEnv } from '../lib/env';

export type FormSubmitMetadata = {
  disableLoader: boolean;
};

export type HandleSubmitCallback = (meta: FormSubmitMetadata) => Promise<any>;

export const useAutoSave = (
  autoSaveEnable: boolean,
  isDirty: boolean,
  handleSubmit: HandleSubmitCallback,
) => {
  const autoSaveFormDirty = useRef<boolean>(false);
  const autoSaveRunning = useRef<boolean>(false);
  const autoSaveCallback = useRef<HandleSubmitCallback>(undefined);

  useEffect(() => {
    autoSaveCallback.current = handleSubmit;
  }, [handleSubmit]);

  useEffect(() => {
    autoSaveFormDirty.current = isDirty;
  }, [isDirty]);

  useEffect(() => {
    if (!autoSaveEnable) return;

    const id = setInterval(
      async () => {
        if (
          !autoSaveFormDirty.current ||
          !autoSaveCallback.current ||
          autoSaveRunning.current
        ) {
          return;
        }

        autoSaveRunning.current = true;
        await autoSaveCallback.current({ disableLoader: true });
        autoSaveRunning.current = false;
      },
      parseInt(getEnv('VITE_AUTO_SAVE_INTERVAL') || '2000'),
    );

    return () => clearInterval(id);
  }, [autoSaveEnable]);
};
